import { DeviceAlert, SensorAlertTypes } from '@/api/customSensorAlerts/types';
import { AlertLine } from '@/charts/types';

export const composeAlertLines = ({
    deviceAlerts = [],
    triggerTypes,
    sensorPositions,
    labelByPosition,
}: {
    deviceAlerts?: DeviceAlert[];
    triggerTypes: SensorAlertTypes[];
    sensorPositions?: number[];
    labelByPosition?: boolean;
}) => {
    return deviceAlerts
        .filter((alert) => {
            if (!alert.enabled) {
                return false;
            }
            if (
                sensorPositions &&
                alert.trigger_details.sensorPosition &&
                !sensorPositions.includes(alert.trigger_details.sensorPosition)
            ) {
                return false;
            }
            return triggerTypes.includes(alert.trigger_type);
        })
        .map<AlertLine>(({ trigger_details: { operator, value, sensorPosition } }) => ({
            operator,
            value,
            sensorPosition,
            label: labelByPosition ? `Sensor ${sensorPosition}` : undefined,
        }));
};

export const alertLineParamsForSensorChart = (sensorPositions: string[], activeSensorPositions?: string[]) => ({
    sensorPositions: (activeSensorPositions?.length ? activeSensorPositions : sensorPositions).map((p) =>
        Number(p.replace(/sensor-/, ''))
    ),
    labelByPosition: sensorPositions.length > 1,
});
